'use client';

import type Error from 'next/error';
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { sendLogToDataDog } from '@/lib/utils/datadogLogger';
import ErrorComponent from '@/components/ErrorComponent';

export interface ErrorProps {
  error: Error & { digest?: string };
}

export default function GlobalError({ error }: ErrorProps) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { 'error-component': 'global-error' },
    });
    sendLogToDataDog(error, {
      component: 'global-error',
      digest: error.digest,
      url: window.location.href,
    });
  }, [error]);

  return (
    <body>
      <ErrorComponent error={error} />
    </body>
  );
}
